<template>
  <nuxt-link
    :data-type="`empty-${item.uuid}`"
    :to="`/search?q=${item.name}&type=experience`"
  >
    Sin resultados. Presiona Enter para agregar más filtros
  </nuxt-link>
</template>

<script>
import LadSearchCommon from './common'

export default {
  name: 'LadSearchEmpty',
  extends: LadSearchCommon,
}
</script>

<style lang="scss">
.autosuggest__results-item {
  a[data-type^='empty'] {
    white-space: inherit !important;
    font-size: 0.9em;
    font-style: italic;
    text-align: center;
  }
}
</style>
